// @flow
import React, { useState } from 'react';
import { CallToAction } from 'components/atoms/callToAction';
import { JobApplicationModal } from 'components/templates/jobApplicationModal';
import { useViewport } from 'components/templates/viewportProvider';

type Props = {
  mode: 'light' | 'dark',
  className?: string,
  roleName?: string,
  jobEmail?: string,
};

export const ApplyForJobButton = (props: Props) => {
  const { mode = 'light', className = '', roleName, jobEmail } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Form modal
  const onClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <CallToAction
        text={'Apply Now'}
        onClick={onClick}
        mode={mode}
        className={className}
        iconType='apply-job'
      />
      <JobApplicationModal
        roleName={roleName && roleName}
        isOpen={isModalOpen}
        onClosePress={closeModal}
        jobEmail={jobEmail}
      />
    </>
  );
};
